import { defineSidepanelMode } from "@/composables/useSidepanel";
import { syncAiPhaseForOpen } from "@/composables/useAiChatSession";
import AiModeContent from "@/components/Sidepanel/AiModeContent.vue";
import AiTabIcon from "@/components/Sidepanel/AiTabIcon.vue";
import NotificationsTabIcon from "@/components/Sidepanel/NotificationsTabIcon.vue";
import ChatHistoryControls from "@/components/AIAgent/ChatHistoryControls.vue";
import AnnotationsPanelContent from "@/components/Sidepanel/AnnotationsPanelContent.vue";
import AnnotationsHeaderActions from "@/components/Sidepanel/AnnotationsHeaderActions.vue";
import AnnotationCreateModalHost from "@/components/Sidepanel/AnnotationCreateModalHost.vue";
import NotificationsPanelContent from "@/components/Core/Notifications/NotificationsPanelContent.vue";
import MyTasksContent from "@/components/Core/Recommendations/MyTasksContent.vue";
import BlockLibraryContent from "@/views/Home/BlockLibraryContent.vue";
import DashboardHistoryContent from "@/views/Dashboard/Components/DashboardHistoryContent.vue";
import SidepanelPortalOutlet from "@/components/Sidepanel/SidepanelPortalOutlet.vue";

// The complete sidepanel tab set, in canonical order. Contextual modes
// (blocks, annotations) come first and only appear while a view registers a
// provider; global modes are always available. Adding a mode = one entry
// here (plus a provider registration if contextual).

defineSidepanelMode(
  {
    id: "blocks",
    title: "Block library",
    order: 0,
    icon: "table-cells",
    component: BlockLibraryContent,
    contentClass: "custom-table-scroll overflow-y-auto",
  },
  { contextual: true },
);

// Bulk-edit panel for selected conversions (Settings > Conversions). The body
// is a portal outlet: the All-conversions tab owns the selection and Teleports
// its toolbar in while at least one conversion is selected.
defineSidepanelMode(
  {
    id: "conversion-selection",
    title: "Edit conversions",
    order: 2,
    icon: "arrow-right-arrow-left",
    component: SidepanelPortalOutlet,
    contentClass: "custom-table-scroll overflow-y-auto",
  },
  { contextual: true },
);

// Contextual: the dashboard editor and the dashboard view register a
// provider while they are open; the shared view does not. Ordered next to
// the widget list it sits beside in the editor.
defineSidepanelMode(
  {
    id: "history",
    title: "Version history",
    order: 3,
    icon: "history",
    component: DashboardHistoryContent,
    contentClass: "custom-table-scroll overflow-y-auto",
  },
  { contextual: true },
);

defineSidepanelMode({
  id: "ai",
  title: "Automagic AI",
  order: 10,
  icon: null,
  tabIcon: AiTabIcon,
  headerIcon: null,
  component: AiModeContent,
  contentClass: "flex flex-col overflow-y-auto",
  headerActions: ChatHistoryControls,
  onOpen: syncAiPhaseForOpen,
});

defineSidepanelMode(
  {
    id: "annotations",
    title: "Annotations",
    order: 20,
    icon: "map-pin",
    component: AnnotationsPanelContent,
    contentClass: "custom-table-scroll overflow-y-auto",
    headerActions: AnnotationsHeaderActions,
    persistent: AnnotationCreateModalHost,
  },
  { contextual: true },
);

defineSidepanelMode({
  id: "notifications",
  title: "Notifications",
  order: 30,
  icon: "bell",
  tabIcon: NotificationsTabIcon,
  component: NotificationsPanelContent,
  contentClass: "custom-table-scroll flex flex-col overflow-y-auto",
});

defineSidepanelMode({
  id: "tasks",
  title: "My Tasks",
  order: 40,
  icon: "check-circle",
  component: MyTasksContent,
});
